module.exports = __webpack_public_path__ + "static/media/align-right.dcdac261.svg";